import { Link } from "react-router-dom";
import { Card, CardBody, Col } from "reactstrap";
import { Href } from "../../../Constants/Constants";
import { H4, P } from "../../../AbstractElements";
import { PlusSquare } from "react-feather";

const AddTitleCard = () => {
  return (
    <Col xxl="3" sm="6" xl="4" className="box-col-4">
      <Card className="common-hover">
        <CardBody>
          <Link className="effect-card" to={Href}>
            <div className="common-box1 common-align">
              <PlusSquare className="flex-shrink-0" />
              <H4 className="text-truncate">Add the title of the card</H4>
            </div>
            <P className="mb-0">This is an example card for you to use. you are able to include subtitles in your according.</P>
            <div className="go-corner">
              <div className="go-arrow" />
            </div>
          </Link>
        </CardBody>
      </Card>
    </Col>
  );
};

export default AddTitleCard;
